import { createWebHistory, createRouter } from "vue-router";
import Home from "../src/components/Home";
import SceltaVeicolo from "../src/components/SceltaVeicolo";
import RicercaModello from "../src/components/RicercaModello";
import Perizia from "../src/components/Perizia";
import Archivio from "../src/components/Archivio";
import HomeForecast from "../src/components/forecast/Home";
import SceltaVeicoloForecast from "../src/components/forecast/SceltaVeicolo";
import RicercaModelloForecast from "../src/components/forecast/RicercaModello";
import Forecast from "../src/components/forecast/Forecast";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/scelta-veicolo",
        name: "SceltaVeicolo",
        component: SceltaVeicolo,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/ricerca-modello",
        name: "RicercaModello",
        component: RicercaModello,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/perizia",
        name: "perizia",
        component: Perizia,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/archivio",
        name: "archivio",
        component: Archivio,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/forecast",
        name: "HomeForecast",
        component: HomeForecast,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/forecast/scelta-veicolo",
        name: "SceltaVeicoloForecast",
        component: SceltaVeicoloForecast,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/forecast/ricerca-modello",
        name: "RicercaModelloForecast",
        component: RicercaModelloForecast,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/forecast/forecast",
        name: "Forecast",
        component: Forecast,
        meta: {
            requiresAuth: true
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior () {
        return { top: 0 }
    }
});

export default router;